import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import classNames from 'classnames';

type Props = {
  html: string | undefined;
  className?: string;
  tag?: string;
  htmlStyle?: string;
};

const HTMLRenderer: React.FC<Props> = ({ html, className, tag = 'div', htmlStyle }) => {
  return React.createElement(tag, {
    dangerouslySetInnerHTML: { __html: html },
    className: classNames(htmlStyle, className),
  });
};

export default HTMLRenderer;
